import React from 'react';
import DialogForm from 'mrf/view/DialogForm';
import { Col, Grid } from 'mrf/view/Grid';
import TextField from 'mrf/view/TextField';

export default function ChangePasswordDialogForm(props) {
    return (
        <DialogForm
            width='1/2'
            title={`Change Password`}
            method='PUT'
            {...props}
        >
            <Grid>
                <Col size={12}>
                    <TextField
                        type='password'
                        label='Current Password'
                        field='currentPassword'
                    />
                </Col>
                <Col size={12}>
                    <TextField
                        type='password'
                        label='New Password'
                        field='newPassword'
                    />
                </Col>
                <Col size={12}>
                    <TextField
                        type='password'
                        label='Confirm New Password'
                        field='confirmNewPassword'
                    />
                </Col>
            </Grid>
        </DialogForm>
    );
}
